/*
 * types/services/dr2am.tasks.roles.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';
import {PbResponseState} from './PbResponseState';
import {PbRole} from './PbRole';

/**
 * The ServiceGetRolesWithUserResponse model module.
 * @module model/ServiceGetRolesWithUserResponse
 * @version version not set
 */
export class ServiceGetRolesWithUserResponse {
  /**
   * Constructs a new <code>ServiceGetRolesWithUserResponse</code>.
   * @alias module:model/ServiceGetRolesWithUserResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ServiceGetRolesWithUserResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ServiceGetRolesWithUserResponse} obj Optional instance to populate.
   * @return {module:model/ServiceGetRolesWithUserResponse} The populated <code>ServiceGetRolesWithUserResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ServiceGetRolesWithUserResponse();
      if (data.hasOwnProperty('roles'))
        obj.roles = ApiClient.convertToType(data['roles'], [PbRole]);
      if (data.hasOwnProperty('state'))
        obj.state = PbResponseState.constructFromObject(data['state']);
    }
    return obj;
  }
}

/**
 * @member {Array.<module:model/PbRole>} roles
 */
ServiceGetRolesWithUserResponse.prototype.roles = undefined;

/**
 * @member {module:model/PbResponseState} state
 */
ServiceGetRolesWithUserResponse.prototype.state = undefined;


